import React, { useState } from "react";
import { Plus } from "lucide-react";
import { AddMemberModal } from "./AddMemberModal";
import { isTetra } from "../../utils/access";

const AdminList = ({ admins, setAdmins, currentUser, filters }) => {
  const [showModal, setShowModal] = useState(false);

  const filteredAdmins = admins.filter((a) => {
    const matchesSearch =
      a.name.toLowerCase().includes(filters?.searchTerm?.toLowerCase() || "") ||
      a.email.toLowerCase().includes(filters?.searchTerm?.toLowerCase() || "");
    if (!matchesSearch) return false;
    if (!filters) return true;
    const { groupId, roleId } = filters;
    
    return true;
  });

  const handleAddMember = (newMember) => {
    setAdmins([...admins, newMember]);
    setShowModal(false);
  };

  // AdminRow component inside the same file
  const AdminRow = ({ admin, index }) => {
    const roleName = admin.role_id === 1 ? "Admin" : "User";

    return (
      <tr className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{admin.name}</td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{admin.phone}</td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{admin.email}</td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{admin.group_id}</td>
        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{roleName}</td>
      </tr>
    );
  };

  return (
    <>

      {currentUser.role_id === "1" && isTetra() && (
        <button
          onClick={() => setShowModal(true)}
          className="flex items-center space-x-2 px-4 py-2 mb-4 bg-blue-500 hover:bg-blue-600 text-white rounded-lg font-medium transition-all duration-200"
        >
          <Plus className="w-4 h-4" />
          <span>Add Member</span>
        </button>
      )}

      <div className="overflow-x-auto bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl border border-white/20">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-neutral-50">
            <tr>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Name</th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Phone</th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Email</th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Group</th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Role</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {filteredAdmins.length > 0 ? (
              filteredAdmins.map((admin, index) => <AdminRow key={admin.id} admin={admin} index={index} />)
            ) : (
              <tr>
                <td colSpan="5" className="px-6 py-12 text-center text-gray-500">No admins found matching your criteria</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <AddMemberModal
        show={showModal}
        onClose={() => setShowModal(false)}
        onAdd={handleAddMember}
        currentGroupId={currentUser.group_id}
      />
    </>
  );
};

export default AdminList;
